// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportBodyViewerActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var withProps = require('recompose').withProps;
  var PrintConstants = require('logic/data/Izenda.PrintConstants');
  var classnames = require('classnames');
  const { get, curry } = require('lodash/fp');
  var actions = compose(
    withProps(function(props) {
      return {
        printingMode: get('location.query.print', props) === 'true' || (props.printingMode && props.setting)
      };
    }),
    withHandlers({
      getContainerStyle: curry(getContainerStyle),
      getContainerClassName: curry(getContainerClassName)
    })
  );

  /**
   * get config style for ReportBody container
   */
  function getContainerStyle(props, exportFormatSetting) {
    if (props.printingMode) {
      var pageSize = PrintConstants.getPageSize(exportFormatSetting.pageSizeKey, exportFormatSetting.orientation);
      return {
        height: PrintConstants.formatCSSValueInInches(pageSize.heightInInches),
        width: PrintConstants.formatCSSValueInInches(pageSize.widthInInches)
      };
    }

    return {};
  }

  /**
   * get config style for ReportBody container
   */
  function getContainerClassName(props, exportFormatSetting) {
    var centerOnPage = exportFormatSetting.centerOnPage;
    return classnames('izenda-ReportBodyViewer u-bgWhite', {
      'center-horizontal': props.printingMode && centerOnPage.horizontally,
      'center-vertical': props.printingMode && centerOnPage.vertically,
      u_fullSize: !props.printingMode,
      u_table: props.setting
    });
  }

  module.exports = actions;
})();



// WEBPACK FOOTER //
// ./ui/share/components/views/Izenda.ReportBodyViewerActions.js